import { cn } from "@dune/ui";
import { AlertTriangle, CheckCircle } from "lucide-react";
import { FilesAnalyze } from "../filesColumns";

interface ValidationStatusProps {
	allDocuments: FilesAnalyze[];
	canValidateByCategory?: boolean;
	className?: string;
}

export const ValidationStatus = ({
	allDocuments,
	canValidateByCategory = false,
	className,
}: ValidationStatusProps) => {
	const toBeProcessed = allDocuments.filter(
		(doc) => doc.file.humanProcessingStatus === "TO_BE_PROCESSED",
	);
	const nonCompliant = allDocuments.filter(
		(doc) => doc.file.humanProcessingStatus === "NON_COMPLIANT",
	);
	const compliant = allDocuments.filter(
		(doc) => doc.file.humanProcessingStatus === "COMPLIANT",
	);

	const allCompliant = compliant.length === allDocuments.length;

	return (
		<div className={cn("space-y-3", className)}>
			<div className="flex items-center gap-2 text-sm font-medium">
				{canValidateByCategory ? (
					<>
						<CheckCircle className="h-5 w-5 text-green-500" />
						<span className="text-green-600">
							Validation possible - Au moins un document conforme par catégorie
						</span>
					</>
				) : allCompliant ? (
					<>
						<CheckCircle className="h-5 w-5 text-green-500" />
						<span className="text-green-600">
							Tous les documents sont conformes
						</span>
					</>
				) : (
					<>
						<AlertTriangle className="h-5 w-5 text-orange-500" />
						<span className="text-orange-600">
							Validation des documents requise
						</span>
					</>
				)}
			</div>

			<div className="space-y-2 pl-7">
				{toBeProcessed.length > 0 && (
					<div className="flex items-center gap-2 text-sm">
						<div className="w-2 h-2 rounded-full bg-orange-500" />
						<span className="text-muted-foreground">
							{toBeProcessed.length} document
							{toBeProcessed.length > 1 ? "s" : ""} à analyser
						</span>
					</div>
				)}

				{nonCompliant.length > 0 && (
					<div className="flex items-center gap-2 text-sm">
						<div className="w-2 h-2 rounded-full bg-red-500" />
						<span className="text-muted-foreground">
							{nonCompliant.length} document{nonCompliant.length > 1 ? "s" : ""}{" "}
							non conforme{nonCompliant.length > 1 ? "s" : ""}
						</span>
					</div>
				)}

				{compliant.length > 0 && (
					<div className="flex items-center gap-2 text-sm">
						<div className="w-2 h-2 rounded-full bg-green-500" />
						<span className="text-muted-foreground">
							{compliant.length} document{compliant.length > 1 ? "s" : ""}{" "}
							conforme{compliant.length > 1 ? "s" : ""}
						</span>
					</div>
				)}
			</div>

			{!canValidateByCategory && !allCompliant && (
				<div className="bg-orange-50 border border-orange-200 rounded-md p-3 mt-3">
					<p className="text-sm text-orange-800">
						<strong>Action requise :</strong> Analysez chaque document et
						définissez son statut (Conforme ou Non conforme) "Assurez-vous
						d'avoir au moins un document conforme par catégorie" avant de
						pouvoir valider le formulaire.
					</p>
				</div>
			)}
		</div>
	);
};
